import React from 'react'

function Checkmark({ height = '83px', width = '83px' }) {
  return (
    <svg width={width} height={height} viewBox='0 0 83 83'>
      <defs>
        <linearGradient
          x1='24.1793946%'
          y1='27.6389598%'
          x2='81.3632131%'
          y2='67.8753805%'
          id='linearGradient-1'>
          <stop stopColor='#61DDAC' offset='0%'></stop>
          <stop stopColor='#37ADFF' offset='100%'></stop>
        </linearGradient>
        <linearGradient
          x1='24.1793946%'
          y1='9.37814817%'
          x2='81.3632131%'
          y2='82.4730447%'
          id='linearGradient-2'>
          <stop stopColor='#61DDAC' offset='0%'></stop>
          <stop stopColor='#37ADFF' offset='100%'></stop>
        </linearGradient>
      </defs>
      <g id='Request' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='Requests---5' transform='translate(-641.000000, -385.000000)'>
          <g id='709510' transform='translate(641.000000, 385.000000)'>
            <path
              d='M81.0840629,10.9191251 C79.8597557,9.69554672 77.8732636,9.6934385 76.6489563,10.9139356 L39.0203644,48.3562437 L25.4440781,33.645248 C24.2709733,32.3748024 22.2875696,32.2924196 21.0120599,33.4626438 C19.7375255,34.6330301 19.6559267,36.6128107 20.8290315,37.8843916 L36.616613,54.9903249 C37.1947942,55.617277 38.0039553,55.9813504 38.8571668,55.999027 C38.880086,56 38.9021924,56 38.9241363,56 C39.7532908,56 40.550911,55.6714421 41.13852,55.087303 L81.0778861,15.3449271 C82.3052818,14.1245922 82.3073949,12.1427034 81.0840629,10.9191251 Z'
              id='Path'
              fill='#dc3d42'></path>//url(#linearGradient-1)
            <path
              d='M79.8717754,38.3717754 C78.1440137,38.3717754 76.7437129,39.7720762 76.7437129,41.5 C76.7437129,60.9341582 60.9341582,76.7437129 41.5,76.7437129 C22.0669766,76.7437129 6.25628711,60.9341582 6.25628711,41.5 C6.25628711,22.0669766 22.0669766,6.25628711 41.5,6.25628711 C43.2277617,6.25628711 44.6282246,4.85598633 44.6282246,3.12822461 C44.6282246,1.40030078 43.2277617,0 41.5,0 C18.6166406,0 0,18.6166406 0,41.5 C0,64.3823867 18.6166406,83 41.5,83 C64.3823867,83 83,64.3823867 83,41.5 C83,39.7722383 81.5996992,38.3717754 79.8717754,38.3717754 Z'
              id='Path'
              fill='#dc3d42'></path>//url(#linearGradient-2)
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Checkmark
